import { render, staticRenderFns } from "./PpvAssessmentRow.vue?vue&type=template&id=4999dfdc&scoped=true"
import script from "./PpvAssessmentRow.vue?vue&type=script&lang=js"
export * from "./PpvAssessmentRow.vue?vue&type=script&lang=js"
import style0 from "./PpvAssessmentRow.vue?vue&type=style&index=0&id=4999dfdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999dfdc",
  null
  
)

export default component.exports